import React from 'react';
import CategoryBadge from '../../../../components/CategoryBadge';
import { LIVE_VIEW_TYPE, POST_VIEW_TYPE } from '../../../../constants/clearance';

const States = ({ isLiveView, clearing, showCategoryLabel = true }) => {
    if (!clearing) {
        return null;
    }

    const viewType = isLiveView ? LIVE_VIEW_TYPE : POST_VIEW_TYPE;
    const categoryEntries = Object.entries(clearing).filter(
        ([key, value]) => value?.category?.label && value?.category?.visibleInViews?.includes(viewType)
    );

    return (
        <>
            {categoryEntries.map(([categoryId, entry]) => {
                const category = entry.category?.label || '';
                const label = entry.label?.label || '';
                const color = entry.label?.color || null;
                const untilDate = entry.untilDate || null;

                return (
                    <CategoryBadge
                        key={categoryId}
                        category={category}
                        label={label}
                        color={color}
                        untilDate={untilDate}
                        isLiveView={isLiveView}
                    />
                );
            })}
        </>
    );
};

export default States;
